import script from "./GrLayoutSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrLayoutSimple.vue?vue&type=script&setup=true&lang=ts"

import "./GrLayoutSimple.vue?vue&type=style&index=0&id=49b94fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b94fb6"]])

export default __exports__